// Sidebar navigation labels i18n fragment
const fragment = {
  vi: {
    // ----- Top-level routes -----
    'nav.stats': 'Thống kê',
    'nav.adminAccounts': 'Tài khoản quản trị',
    'nav.telegramBot': 'Bot Telegram',
    'nav.legalCenter': 'Trung tâm Pháp lý',

    // ----- Collapse group headers -----
    'nav.socialAccounts': 'Tài khoản mạng xã hội',
    'nav.contentPosts': 'Nội dung & bài viết',
    'nav.guides': 'Hướng dẫn sử dụng',
    'nav.guidePinterest': 'Đăng Pin Pinterest',
    'nav.accountPages': 'TRANG TÀI KHOẢN',

    // ----- Social accounts group -----
    'nav.facebookUpdate': 'Cập nhật tài khoản Facebook',
    'nav.facebookCreate': 'Tạo tài khoản Facebook',
    'nav.pagePosts': 'Bài viết của Page',
    'nav.pageList': 'Danh sách Page',
    'nav.facebookAccount': 'Tài khoản Facebook',
    'nav.messengerInbox': 'Messenger Inbox',
    'nav.instagramUpdate': 'Cập nhật tài khoản Instagram',
    'nav.instagramCreate': 'Tạo tài khoản Instagram',
    'nav.instagramDetail': 'Chi tiết tài khoản Instagram',
    'nav.instagramAccount': 'Tài khoản Instagram',
    'nav.youtubeVideos': 'Video kênh YouTube',
    'nav.youtubeScheduledShares': 'Lịch chia sẻ YouTube',
    'nav.youtubeUpdate': 'Cập nhật tài khoản YouTube',
    'nav.youtubeCreate': 'Tạo tài khoản YouTube',
    'nav.youtubeAccount': 'Tài khoản YouTube',
    'nav.tiktokDetail': 'Chi tiết tài khoản Tiktok',
    'nav.tiktokVideos': 'Video TikTok của tài khoản',
    'nav.tiktokUpdate': 'Cập nhật tài khoản Tiktok',
    'nav.tiktokConnect': 'Kết nối tài khoản Tiktok',
    'nav.tiktokAccount': 'Tài khoản Tiktok',
    'nav.pinterestDetail': 'Chi tiết tài khoản Pinterest',
    'nav.pinterestUpdate': 'Cập nhật tài khoản Pinterest',
    'nav.pinterestCreate': 'Tạo tài khoản Pinterest',
    'nav.pinterestAccount': 'Tài khoản Pinterest',
    'nav.pinterestPost': 'Bài viết Pinterest',
    'nav.pinterestPostCreate': 'Tạo Pin Pinterest',
    'nav.pinterestPostUpdate': 'Sửa Pin Pinterest',
    'nav.xUpdate': 'Cập nhật tài khoản X',
    'nav.xCreate': 'Tạo tài khoản X',
    'nav.xAccount': 'Tài khoản X',
    'nav.googleCreate': 'Tạo tài khoản Google',
    'nav.googleAccount': 'Tài khoản Google',
    'nav.telegraphAccount': 'Tài khoản Telegraph',
    'nav.threadsUpdate': 'Cập nhật tài khoản Threads',
    'nav.threadsConnect': 'Kết nối tài khoản Threads',
    'nav.threadsDetail': 'Chi tiết tài khoản Threads',
    'nav.threadsAccountPosts': 'Bài viết của tài khoản Threads',
    'nav.threadsAccount': 'Tài khoản Threads',

    // ----- Content & posts group -----
    'nav.facebookPostUpdate': 'Sửa bài viết Facebook',
    'nav.facebookPostCreate': 'Tạo bài viết Facebook',
    'nav.facebookPost': 'Bài viết Facebook',
    'nav.xPostUpdate': 'Sửa bài viết X',
    'nav.xPostCreate': 'Tạo bài viết X',
    'nav.xPost': 'Bài viết X',
    'nav.threadsPostUpdate': 'Sửa bài viết Threads',
    'nav.threadsPostCreate': 'Tạo bài viết Threads',
    'nav.threadsPost': 'Bài viết Threads',
    'nav.commentDetail': 'Chi tiết comment',
    'nav.commentUpdate': 'Sửa comment',
    'nav.commentCreate': 'Tạo comment',
    'nav.commentBulk': 'Bulk schedule comment',
    'nav.comments': 'Comment bài viết',
    'nav.commentTemplates': 'Comment templates',
    'nav.autoCommentRules': 'Auto-comment rules',
    'nav.instagramPostUpdate': 'Sửa bài viết Instagram',
    'nav.instagramPostCreate': 'Tạo bài viết Instagram',
    'nav.instagramPost': 'Bài viết Instagram',
    'nav.telegraphPostUpdate': 'Sửa bài viết Telegraph',
    'nav.telegraphPostCreate': 'Tạo bài viết Telegraph',
    'nav.telegraphPost': 'Bài viết Telegraph',
    'nav.tiktokPostUpdate': 'Sửa bài viết TikTok',
    'nav.tiktokPostCreate': 'Tạo bài viết TikTok',
    'nav.tiktokPost': 'Bài viết TikTok',
    'nav.scrapboxPostUpdate': 'Sửa bài viết Scrapbox',
    'nav.scrapboxPostCreate': 'Tạo bài viết Scrapbox',
    'nav.scrapboxPost': 'Bài viết Scrapbox',

    // ----- Account pages group -----
    'nav.profile': 'Hồ sơ',
  },
  en: {
    // ----- Top-level routes -----
    'nav.stats': 'Statistics',
    'nav.adminAccounts': 'Admin accounts',
    'nav.telegramBot': 'Telegram Bot',
    'nav.legalCenter': 'Legal Center',

    // ----- Collapse group headers -----
    'nav.socialAccounts': 'Social accounts',
    'nav.contentPosts': 'Content & posts',
    'nav.guides': 'User guide',
    'nav.guidePinterest': 'Publish a Pinterest Pin',
    'nav.accountPages': 'ACCOUNT PAGES',

    // ----- Social accounts group -----
    'nav.facebookUpdate': 'Update Facebook account',
    'nav.facebookCreate': 'Add Facebook account',
    'nav.pagePosts': 'Page posts',
    'nav.pageList': 'Page list',
    'nav.facebookAccount': 'Facebook accounts',
    'nav.messengerInbox': 'Messenger Inbox',
    'nav.instagramUpdate': 'Update Instagram account',
    'nav.instagramCreate': 'Add Instagram account',
    'nav.instagramDetail': 'Instagram account detail',
    'nav.instagramAccount': 'Instagram accounts',
    'nav.youtubeVideos': 'YouTube channel videos',
    'nav.youtubeScheduledShares': 'YouTube scheduled shares',
    'nav.youtubeUpdate': 'Update YouTube account',
    'nav.youtubeCreate': 'Add YouTube account',
    'nav.youtubeAccount': 'YouTube accounts',
    'nav.tiktokDetail': 'TikTok account detail',
    'nav.tiktokVideos': 'TikTok account videos',
    'nav.tiktokUpdate': 'Update TikTok account',
    'nav.tiktokConnect': 'Connect TikTok account',
    'nav.tiktokAccount': 'TikTok accounts',
    'nav.pinterestDetail': 'Pinterest account detail',
    'nav.pinterestUpdate': 'Update Pinterest account',
    'nav.pinterestCreate': 'Add Pinterest account',
    'nav.pinterestAccount': 'Pinterest accounts',
    'nav.pinterestPost': 'Pinterest posts',
    'nav.pinterestPostCreate': 'Create Pinterest Pin',
    'nav.pinterestPostUpdate': 'Edit Pinterest Pin',
    'nav.xUpdate': 'Update X account',
    'nav.xCreate': 'Add X account',
    'nav.xAccount': 'X accounts',
    'nav.googleCreate': 'Add Google account',
    'nav.googleAccount': 'Google accounts',
    'nav.telegraphAccount': 'Telegraph accounts',
    'nav.threadsUpdate': 'Update Threads account',
    'nav.threadsConnect': 'Connect Threads account',
    'nav.threadsDetail': 'Threads account detail',
    'nav.threadsAccountPosts': 'Threads account posts',
    'nav.threadsAccount': 'Threads accounts',

    // ----- Content & posts group -----
    'nav.facebookPostUpdate': 'Edit Facebook post',
    'nav.facebookPostCreate': 'Create Facebook post',
    'nav.facebookPost': 'Facebook posts',
    'nav.xPostUpdate': 'Edit X post',
    'nav.xPostCreate': 'Create X post',
    'nav.xPost': 'X posts',
    'nav.threadsPostUpdate': 'Edit Threads post',
    'nav.threadsPostCreate': 'Create Threads post',
    'nav.threadsPost': 'Threads posts',
    'nav.commentDetail': 'Comment detail',
    'nav.commentUpdate': 'Edit comment',
    'nav.commentCreate': 'Create comment',
    'nav.commentBulk': 'Bulk schedule comment',
    'nav.comments': 'Post comments',
    'nav.commentTemplates': 'Comment templates',
    'nav.autoCommentRules': 'Auto-comment rules',
    'nav.instagramPostUpdate': 'Edit Instagram post',
    'nav.instagramPostCreate': 'Create Instagram post',
    'nav.instagramPost': 'Instagram posts',
    'nav.telegraphPostUpdate': 'Edit Telegraph post',
    'nav.telegraphPostCreate': 'Create Telegraph post',
    'nav.telegraphPost': 'Telegraph posts',
    'nav.tiktokPostUpdate': 'Edit TikTok post',
    'nav.tiktokPostCreate': 'Create TikTok post',
    'nav.tiktokPost': 'TikTok posts',
    'nav.scrapboxPostUpdate': 'Edit Scrapbox post',
    'nav.scrapboxPostCreate': 'Create Scrapbox post',
    'nav.scrapboxPost': 'Scrapbox posts',

    // ----- Account pages group -----
    'nav.profile': 'Profile',
  },
};

export default fragment;
